<ecoupon-shared-ui-lib-ecoupon-form [data]="detail" [pathFrom]="path" [errMsg]="errMsg()" [id]="nameRoute()"
    (emitEcouponForm)="emitForm($event)"></ecoupon-shared-ui-lib-ecoupon-form>